const CURRENT_PREFIX = 'aviseraplanner';
// Keep one release of read compatibility for preferences and recovery drafts
// created before the product rename. Construct the retired prefix so it cannot
// be mistaken for a current application identifier by source audits.
const RETIRED_PREFIX = ['sight', 'line'].join('');

export const storageKey = suffix => `${CURRENT_PREFIX}.${suffix}`;

export function readStorage(suffix) {
  const current = storageKey(suffix);
  const value = localStorage.getItem(current);
  if (value != null) return value;
  const retired = `${RETIRED_PREFIX}.${suffix}`;
  const migrated = localStorage.getItem(retired);
  if (migrated != null) {
    localStorage.setItem(current, migrated);
    localStorage.removeItem(retired);
  }
  return migrated;
}

export function writeStorage(suffix, value) {
  localStorage.setItem(storageKey(suffix), value);
}

export function removeStorage(suffix) {
  localStorage.removeItem(storageKey(suffix));
  localStorage.removeItem(`${RETIRED_PREFIX}.${suffix}`);
}
